import React from 'react'
import ComingSoon from '../../pages/ComingSoon';

const NonConformance = () => {
  return (
    <div className=''>
        <ComingSoon />
    </div>
  )
}

export default NonConformance;